export default __webpack_public_path__ + "static/media/bg1.e9b79122.jpg";